<template>
  <div class="vx-card" style="height: 85vh;">
    <form-wizard color="rgba(var(--vs-primary), 1)" finishButtonText="Kaydet" backButtonText="Geri" nextButtonText="İleri" ref="formWizard" stepSize="xs" shape="tab" @on-complete="sendRecord">
      <!--******************Tab 1***************************-->
      <tab-content title="Müşteri Seçiniz" icon="feather icon-user">
        <div class="vx-row justify-between flex mt-2">
          <div class="vx-col justify-end flex md:w-1/3 small-icon">
            <vs-button color="success" type="filled" @click="addNewCustomer">Müşteri Ekle</vs-button>
          </div>
          <div class="vx-col md:w-1/3 flex small-icon">
            <vs-input icon-pack="feather" icon="icon-user" class="w-full" placeholder="Müşteri Ara" v-model="searchQuery" @keyup="delayedSearch" />
          </div>
          <div class="vx-col md:w-1/3 flex small-icon">
            <vs-button type="border" class="ml-5" @click="search">Ara</vs-button>
          </div>
          <add-new-customer :addnew="addNewCust" :withAdditionalData="true" v-if="addNewCust" @hideAddNewRegister="hideAddNewCust"></add-new-customer>
          <div class="vx-row mr-2 mt-5 w-full">
            <div class="vx-col w-full" v-if="this.$route.name != 'SaleWizardWithCustomerId'">
              <vs-table noDataText="Tabloda Veri Yok" :data="customerSearch">
                <template slot="thead">
                  <vs-th hidden>id</vs-th>
                  <vs-th class="md:w-1/3">Müşteri</vs-th>
                  <vs-th class="md:w-1/6">Telefon</vs-th>
                  <vs-th class="md:w-1/3">Adres</vs-th>
                  <vs-th class="md:w-1/6">Seç</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="data[i].userId" v-for="(tr, i) in data" class="pt-0 pb-1" :state="tr.span ? 'danger' : ''" :title="tr.span ? 'Kendisiyle iletişim kurulmasını istemiyor!' : ''">
                    <vs-td hidden :data="data[i].userId" class="pt-0 pb-1">{{ data[i].userId }}</vs-td>

                    <vs-td :data="tr.firstName + ' ' + (tr.lastName || '')" class="pt-0 pb-1">{{ tr.firstName + " " + (tr.lastName || "") }}<b v-if="tr.span"> Kendisiyle iletişim kurulmasını istemiyor</b></vs-td>

                    <vs-td :data="data[i].phone" class="pt-0 pb-1">
                      {{ data[i].phone }}
                    </vs-td>

                    <vs-td :data="data[i].address" class="pt-0 pb-1">
                      {{ data[i].address }}
                    </vs-td>

                    <td class="flex">
                      <vs-radio icon="CheckSquareIcon" v-model="selectedCustomerRadio" :vs-value="i" @change="selectItem(i)" />
                      <feather-icon title="Müşteri Bilgileri" icon="InfoIcon" svgClasses="h-10 w-10 text-success hover:text-primary cursor-pointer p-2 ml-5" @click="$router.push('/contactsView/' + tr.customerId).catch((err) => {})" />
                    </td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
          <div class="vx-row mt-3 mr-2 w-full">
            <div class="vx-col md:w-1/2">
              <label class="text-sm"><b>Adı Soyadı</b></label>
              <vs-input disabled name="customerName" class="w-full mb-2 mt-0" placeholder="Adı Soyadı" v-model="saveOrder.customerName" />
              <span v-show="errors.has('customerName')" class="errorfonts">{{ errors.first("customerName") }}</span>
            </div>
            <div class="vx-col md:w-1/2">
              <label class="text-sm"><b>Telefon</b></label>
              <vs-input disabled name="customerPhone" class="w-full mb-2 mt-0" :placeholder="!saveOrder.customerId ? 'Telefonu' : ''" v-model="saveOrder.customerPhone" />
            </div>
          </div>

          <div class="vx-row mr-2 w-full">
            <div class="vx-col md:w-1/2">
              <label class="text-sm"><b>Fatura Adresi</b></label>
              <vs-textarea disabled name="customerBillAddress" class="w-full mb-2 mt-0" v-model="saveOrder.customerBillAddress" />
            </div>
            <div class="vx-col md:w-1/2">
              <label class="text-sm"><b>Teslimat Adresi</b></label>
              <vs-textarea name="customerDeliverAddress" class="w-full mb-2 mt-0" v-model="saveOrder.customerDeliverAddress" />
              <span v-show="errors.has('customerDeliverAddress')" class="errorfonts">{{ errors.first("customerDeliverAddress") }}</span>
            </div>
            <div class="vx-col md:w-1/2">
              <label class="text-sm"><b>Düzenleme Tarihi</b></label>
              <input class="w-full mb-2 mt-0" type="datetime-local" v-model="saveOrder.arrangementDate" name="arrangementDate" @change="isValid($event, '', 'red')" />
            </div>
            <div class="vx-col md:w-1/2">
              <label class="text-sm"><b>Geçerlilik Tarihi</b></label>
              <input class="w-full mb-2 mt-0" type="datetime-local" v-model="saveOrder.validityDate" name="validityDate" />
            </div>
          </div>
        </div>
        <div class="vx-row justify-end flex mt-3">
          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-right" @click="$refs.formWizard.nextTab()">İleri</vs-button>
          </div>
        </div>
      </tab-content>

      <!--******************Tab 2***************************-->
      <tab-content title="Satış Türleri Seçiniz" icon="feather icon-dollar-sign">
        <div class="vx-row justify-between flex mt-2">
          <div class="vx-col md:w-1/3">
            <label class="mr-2"><b>Satış Türü</b></label>
            <v-select
              v-model="saveOrder.saleOrderType"
              class="w-full select-large mb-2 style-chooser"
              name="saleOrderTypesOptions"
              placeholder="Satış Türü seçin"
              :options="saleOrderTypesOptions"
              :reduce="(saleOrderTypesOptions) => saleOrderTypesOptions.id"
              label="value"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
            <span v-show="errors.has('saleOrderTypesOptions')" class="errorfonts">{{ errors.first("saleOrderTypesOptions") }}</span>
          </div>
          <div class="vx-col md:w-1/3">
            <label class="mr-2"><b>Ödeme Türü</b></label>
            <v-select
              v-model="saveOrder.selectedPaymentType"
              class="w-full select-large mb-2 style-chooser"
              placeholder="Ödeme türü seçin"
              :options="selectedPaymentTypeOptions"
              name="selectedPaymentType"
              :reduce="(selectedPaymentTypeOptions) => selectedPaymentTypeOptions.id"
              label="value"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
            <span v-show="errors.has('selectedPaymentType')" class="errorfonts">{{ errors.first("selectedPaymentType") }}</span>
          </div>
          <div class="vx-col md:w-1/3">
            <label class="mr-2"><b>Teslimat Türü</b></label>
            <v-select
              v-model="saveOrder.saleDeliveryType"
              name="saleDeliveryTypeOptions"
              class="w-full select-large mb-2 style-chooser"
              placeholder="Teslimat türü Seçin"
              :options="saleDeliveryTypeOptions"
              :reduce="(saleDeliveryTypeOptions) => saleDeliveryTypeOptions.id"
              label="value"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
            <span v-show="errors.has('saleDeliveryTypeOptions')" class="errorfonts">{{ errors.first("saleDeliveryTypeOptions") }}</span>
          </div>
        </div>
        <div class="vx-row justify-between flex mt-2">
          <div class="vx-col md:w-1/3">
            <label class="mr-2"><b>Döviz</b></label>
            <v-select
              name="moneyCurrencyOptions"
              class="w-full"
              placeholder="Para birimi seçin"
              v-model="saveOrder.salePriceCurrencyId"
              :options="moneyCurrencyOptions"
              :clearable="false"
              :reduce="(moneyCurrencyOptions) => moneyCurrencyOptions.id"
              label="name"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col md:w-1/3">
            <span class="mr-2"
              ><b>{{ saveOrder.taxIncluded ? "KDV Dahil" : "KDV Hariç" }}</b></span
            >
            <vs-switch size="small" v-model="saveOrder.taxIncluded" @change="calculate" />
          </div>
          <div class="vx-col md:w-1/3">
            <span
              ><b>
                Tam Fatura
              </b></span
            >

            <vs-switch v-model="saveOrder.isFullInvoice" />
          </div>
          <div class="vx-row ml-0 mt-5 w-full">
            <div class="vx-col w-full">
              <label class="text-sm"><b>Sipariş Detayları</b></label>
              <vs-textarea name="orderNote" class="w-full mb-2 mt-0" v-model="saveOrder.orderNote" />
            </div>
          </div>
        </div>
        <div class="vx-row justify-between flex mt-3">
          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-left" @click="$refs.formWizard.prevTab()">Geri</vs-button>
          </div>

          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-right" @click="$refs.formWizard.nextTab()">İleri</vs-button>
          </div>
        </div>
      </tab-content>
      <!--***********Tab 3 ****************-->
      <tab-content title="Sepetteki Ürünler" class="mb-5" icon="feather icon-shopping-cart" lazy="true">
        <div class="vx-row md:w-1/3">
          <div class="vx-col md:w-2/3 w-full">
            <label class="text-sm"><b>Ürün</b></label>
            <vs-input type="number" class="w-full" size="large" v-model="v1Search.productId" />
          </div>
          <div class="vx-col mt-5">
            <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
            <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
          </div>
        </div>
        <vs-prompt vs-title="Sepete Ürün Ekle" vs-button-cancel="border" vs-accept-text="Ekle" vs-cancel-text="Vazgeç" @vs-accept="saveSaleOrderBasket()" @vs-close="cancel" @vs-cancel="cancel" vs-color="warning" :vs-active.sync="saveBasketPopup">
          <div>
            <ag-grid-vue
              style="height: 50vh;"
              ref="agGridTable"
              :gridOptions="gridOptions"
              class="ag-theme-material w-100 my-4 ag-grid-table"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="saleProductList"
              rowSelection="multiple"
              colResizeDefault="shift"
              :animateRows="true"
              :floatingFilter="true"
              :pagination="true"
              :paginationPageSize="paginationPageSize"
              :suppressPaginationPanel="true"
              :rowClassRules="rowClassRules"
            ></ag-grid-vue>
          </div>
        </vs-prompt>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-table search noDataText="Ürün Bulunamadı!" :data="saleOrderBasketList" :maxItems="10" :pagination="true">
              <template slot="thead">
                <vs-th>Ürün Id</vs-th>
                <vs-th>Ürün</vs-th>
                <vs-th>Depo</vs-th>
                <vs-th>Birim Fiyatı</vs-th>
                <vs-th>Satış Fiyatı</vs-th>
                <vs-th>Adet</vs-th>
                <vs-th>Toplam</vs-th>
                <vs-th>İşlem</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(tr, i) in data" :key="i">
                  <vs-td style="width: 10%;">{{ tr.productId }}</vs-td>
                  <vs-td style="width: 35%;">{{ tr.productName }}</vs-td>
                  <vs-td style="width: 15%;">{{ tr.warehouseName }}</vs-td>
                  <vs-td style="width: 10%;">{{ tr.sellPrice + " " + tr.logo }}</vs-td>
                  <vs-td style="width: 10%;">
                    <vs-input type="number" size="small" class="w-full" v-model="tr.salePrice" />
                  </vs-td>

                  <vs-td style="width: 10%;">
                    <feather-icon icon="MinusSquareIcon" svgClasses="h-full w-full  hover:text-primary cursor-pointer" @click="reduceProduct(tr)" />
                    <span style="margin-left: 5px; margin-right: 5px;">{{ tr.amount }}</span>
                    <feather-icon icon="PlusSquareIcon" svgClasses="h-full w-full   hover:text-primary cursor-pointer" @click="increaseProduct(tr)" />
                  </vs-td>
                  <vs-td style="width: 35%;"
                    >{{ tr.salePrice * tr.amount }}

                    <v-select
                      name="moneyCurrencyOptions"
                      class="select"
                      placeholder="Para birimi seçin"
                      v-model="saveOrder.salePriceCurrencyId"
                      :options="moneyCurrencyOptions"
                      :clearable="false"
                      disabled
                      :reduce="(moneyCurrencyOptions) => moneyCurrencyOptions.id"
                      label="name"
                    >
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>
                  <vs-td>
                    <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="deleteSaleOrderBasket(tr)"></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div class="vx-row justify-between flex mt-3">
          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-left" @click="$refs.formWizard.prevTab()">Geri</vs-button>
          </div>

          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-right" @click.native="sendRecord">Kaydet</vs-button>
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";
import addNewCustomer from "../contacts/addNewPrompt.vue";
import ProductSearch from "../Search/ProductSearch.vue";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
export default {
  components: {
    FormWizard,
    TabContent,
    vSelect,
    addNewCustomer,
    ProductSearch,
    AgGridVue,
  },
  data() {
    return {
      selectedCurrency: null,
      saleOrderBasketList: [],
      moneyCurrencyOptions: [],
      saleOrderTypesOptions: [],
      selectedPaymentTypeOptions: [],
      saleDeliveryTypeOptions: [],

      saveOrder: {
        products: [],
        id: null,
        date: null,
        userId: null,
        userName: null,
        orderNote: null,
        sellPrice: null,
        productId: null,
        productName: null,
        amount: null,
        salePrice: null,
        salePriceCurrencyId: 3,
        logo: null,
        currency: null,
        customerId: null,
        customerName: null,
        customerPhone: null,
        customerBillAddress: null,
        customerDeliverAddress: null,
        saleOrderType: null,
        arrangementDate: null,
        validityDate: null,
        selectedPaymentType: null,
        saleDeliveryType: null,
        taxIncluded: 1,
        isFullInvoice: null,
      },

      addNewCust: false,
      grandTotal: {
        sumUnitPrice: 0,
        sumSalePrice: 0,
        sumquantity: 0,
        price: 0,
        discountPercent: 0,
      },
      kdvRate: 0.18,
      searchQuery: "",
      delayedSearchTimer: null,
      customerSearch: [],
      selectedCustomerRadio: {}.empty,

      productSearchPopupParent: false,
      saveBasketPopup: false,
      saleProductList: [],
      v1Search: { productId: null, productName: null, stock: null, wareHouseId: null, wareHouse: null, forceBarcode: null, salePrice: null, salePriceCurrencyId: null },
      delayedSearchTimer: "",
      gridApi: null,
      rowClassRules: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          checkboxSelection: true,
          headerName: "Ürün Id",
          field: "productId",
          editable: false,
          width: 200,
        },
        {
          headerName: "Ürün",
          field: "productName",
          editable: false,
          width: 300,
        },
        {
          headerName: "Stok",
          field: "stock",
          editable: false,
          width: 100,
        },
        {
          headerName: "Depo",
          field: "wareHouse",
          filter: true,
          editable: false,
          width: 200,
        },
        {
          headerName: "Birim Fiyatı",
          field: "salePriceStr",
          editable: false,
          width: 100,
        },
        {
          headerName: "Satış Fiyatı",
          field: "sellPrice",
          editable: true,
          width: 150,
        },
        {
          headerName: "Adet",
          field: "amount",
          editable: true,
          width: 100,
        },
      ],
    };
  },
  methods: {
    ProductSearchPopupClosedParent: async function (v) {
      this.productSearchPopupParent = false;
      if (v) {
        this.v1Search.productId = v.productId;
        this.saveBasketPopup = true;
        this.saleProductList = await repository.postEntity("Product/getProductsV1Search", { ProductId: this.v1Search.productId }).then((row) => row.list);
      } else {
        this.v1Search.productId = null;
      }
    },
    saveSaleOrderBasket: async function () {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
      this.saleOrderBasket = {
        productId: this.selectedRow.productId,
        salePrice: this.selectedRow.sellPrice,
        salePriceCurrencyId: this.selectedRow.salePriceCurrencyId,
        amount: this.selectedRow.amount,
        warehouseId: this.selectedRow.wareHouseId,
      };

      let resultConfirm = await this.$swal.fire({
        icon: "warning",
        text: `${this.saleOrderBasket.productId} Id'li Ürünü sepete eklemek istediğinize emin misiniz?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (resultConfirm.isConfirmed) {
        this.$vs.loading();
        let saveBasket = await repository.postEntity("Product/saveSaleOrderBasket", this.saleOrderBasket).then((r) => r.list);
        this.$vs.loading.close();
        await this.$swal.fire({ icon: "success", title: "Ürün sepete eklenmiştir." });
        this.showSaleOrderBasket();
      } else {
        return;
      }
    },

    cancel() {},
    showSaleOrderBasket: async function () {
      this.$vs.loading();
      let list = await repository.postEntity("Product/showSaleOrderBasket", { UserId: this.$store.state.userData.userId }).then((r) => r.list);
      this.saleOrderBasketList = list;
      this.$vs.loading.close();
    },
    calculate: function () {
      this.grandTotal.sumUnitPrice = 0;
      this.grandTotal.sumquantity = 0;
      this.grandTotal.priceDiscounted = 0;
      this.grandTotal.discountPercent = 0;
      let sumSalePrice = 0;
      //kdv yüzdesi
      let a = 0;
      if (this.saleOrderBasketList.length > 0) {
        for (let i = 0; i < this.saleOrderBasketList.length; i++) {
          //toplam birim fiyat

          this.grandTotal.sumUnitPrice = this.saleOrderBasketList[i].price * this.saleOrderBasketList[i].amount + this.grandTotal.sumUnitPrice;

          //toplam adet
          this.grandTotal.sumquantity = this.grandTotal.sumquantity + parseInt(this.saleOrderBasketList[i].amount);

          sumSalePrice = this.saleOrderBasketList[i].salePrice * this.saleOrderBasketList[i].amount + sumSalePrice;

          if (this.saveOrder.taxIncluded) a = this.kdvRate;
          else a = 0;

          //toplam indirmli fiyat
          this.grandTotal.priceDiscounted = (this.saleOrderBasketList[i].salePrice + this.saleOrderBasketList[i].salePrice * a) * parseInt(this.saleOrderBasketList[i].amount) + this.grandTotal.priceDiscounted;

          //toplam indirim yüzdesi
          this.grandTotal.discountPercent = (sumSalePrice - this.grandTotal.sumUnitPrice) / this.grandTotal.sumUnitPrice;
        }
      }
    },
    isValid(event, success, fail) {
      if (event instanceof Event) {
        if (event["target"] && event.target instanceof HTMLInputElement) {
          let e = document.getElementsByName(event.target.name);
          if (this.isDateTime(event)) {
            if (e && e[0]) {
              e[0].style["color"] = success;
            }
          } else {
            if (e && e[0]) e[0].style["color"] = fail;
          }
        }
      }
      return false;
    },
    isDateTime(d) {
      if (d instanceof Date) {
        return !isNaN(d);
      }
      if (typeof d === "string") {
        return this.isDateTime(new Date(d));
      }
      if (d instanceof Event) {
        if (d["target"] && d.target instanceof HTMLInputElement) return this.isDateTime(new Date(d.target.value));
      }
    },
    addNewCustomer() {
      this.addNewCust = true;
    },
    hideAddNewCust() {
      this.addNewCust = false;
    },
    delayedSearch() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(() => {
        if (this.searchQuery && this.searchQuery.length > 3) this.search();
      }, 500);
    },
    selectItem(i) {
      if (!this.customerSearch[i].isReadyForInvoice) {
        if (!this.customerSearch[i].isOnlineCustomer) {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: this.customerSearch[i].error,
          });
          return;
        }
      }
      this.selectedCustomer = JSON.parse(JSON.stringify(this.customerSearch[i]));
      if (this.selectedCustomer.lastName != null) this.saveOrder.customerName = this.selectedCustomer.firstName + " " + this.selectedCustomer.lastName;
      else {
        this.saveOrder.customerName = this.selectedCustomer.firstName;
      }
      this.saveOrder.customerId = this.selectedCustomer.customerId;
      this.saveOrder.customerPhone = this.selectedCustomer.phone;
      this.saveOrder.customerBillAddress = this.selectedCustomer.billingAddress;
      this.saveOrder.customerDeliverAddress = this.selectedCustomer.address;
    },
    search: async function () {
      this.customerSearch = await repository.getWithParam("Customer/search", "searchQuery=" + this.searchQuery).then((r) => r.list);
      if (this.customerSearch && this.customerSearch.length == 1) this.selectItem(0);
      for (let i = 0; i < this.customerSearch.length; i++) {
        let c = this.customerSearch[i];
        let span = c.firstName.indexOf("</span>");
        if (span > 0) {
          c.firstName = c.firstName.substr(span + 7).trim();
          c.span = true;
        }
      }
      return this.customerSearch;
    },
    reduceProduct: async function (tr) {
      if (tr.amount != 0) tr.amount -= 1;
    },
    increaseProduct: async function (tr) {
      tr.amount += 1;
    },

    deleteSaleOrderBasket: async function (tr) {
      this.saveOrder = tr;
      let basketId = parseInt(this.saveOrder.id);
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (resultConfirm2.isConfirmed) null;
      else return;

      await repository.deleteWithParam("saleWizard/saleOrderBasketDelete?basketId", basketId);
      await this.showSaleOrderBasket();
    },
    getCurrencies: async function () {
      this.moneyCurrencyOptions = await repository.getAll("Accounting/getCurrencies").then((r) => r.list);
    },
    getPaymentTypes: async function () {
      this.$vs.loading();
      this.selectedPaymentTypeOptions = await repository.getAll("Accounting/getPaymentTypes").then((row) => row.list);
      this.$vs.loading.close();
    },
    getSaleDeliveryType: async function () {
      this.$vs.loading();
      this.saleDeliveryTypeOptions = await repository.getAll("General/getDeliveryTypes").then((row) => row.list);
      this.$vs.loading.close();
    },

    getOrderTypes: async function () {
      this.$vs.loading();
      this.saleOrderTypesOptions = await repository.getAll("Sale/getOrderTypes").then((row) => row.list);
      this.$vs.loading.close();
    },

    sendRecord: async function () {
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: "Sepetteki ürünler silinip teklife dönüşecektir.",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (resultConfirm2.isConfirmed) null;
      else return;

      for (let a = 0; a < this.saleOrderBasketList.length; a++) {
        let price = parseFloat(this.saleOrderBasketList[a].salePrice);
        if (isNaN(price)) return;

        //measure price without discounted
        if (this.saveOrder.taxIncluded) price = price * 0.8474576271186440677966101694915254237288135593220338983050847457;

        this.saleOrderBasketList[a].priceDiscounted = price;
        this.saleOrderBasketList[a].priceWithTaxes = price * 1.18;
        this.saleOrderBasketList[a].salePrice = price;
      }

      if (this.saleOrderBasketList.length > 0) this.calculate();
      this.saveOrder.products.splice(0, this.saveOrder.products.length);
      for (let i = 0; i < this.saleOrderBasketList.length; i++) {
        this.saveOrder.products.push({
          productId: this.saleOrderBasketList[i].productId,
          productType: 1,
          productAmount: this.saleOrderBasketList[i].amount,
          discount: 0,
          discountPercent: 0,
          price: this.saleOrderBasketList[i].salePrice,
          priceId: this.saleOrderBasketList[i].salePriceCurrencyId,
          priceDiscounted: this.saleOrderBasketList[i].salePrice,
          lineType: 1,
          wareHouseId: this.saleOrderBasketList[i].warehouseId,
          id: -1,
        });
      }

      ///// Kurallar eklenecek //////////////////
      //Bu kısım pair ürünler için belirli bir sayıda satılması için kodlanmıştır.
      if (this.$store.state.userData.authorizationList.find((f) => f.authorizationId == "11") != null) {
        null;
      } else {
        let pairProductList = this.saleOrderBasketList.filter((r) => [1638, 1917, 2937, 1347, 1348, 1349, 1350, 1351, 1352, 1354, 1355, 1357, 3156, 3006].includes(r.productId));
        let sumOfQuantity = pairProductList.reduce((acc, ele) => {
          return acc + ele.amount;
        }, 0);

        if (sumOfQuantity > 0 && sumOfQuantity < 3) {
          await this.$swal.fire({
            icon: "warning",
            title: "Ürün Grubunda Yetersiz Sayı Hatası",
            text: "ProductId si   [1638, 1917, 2937, 1347, 1348, 1349, 1350, 1351, 1352, 1354, 1355, 1357, 3156, 3006] olan ürünler için en az toplam 3 adet olmalıdır.",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }
      }

      //Bu kısım Sale Rule içindir.

      if (this.$store.state.userData.authorizationList.find((f) => f.authorizationId == "19") != null) {
        null;
      } else {
        let fullInvoiceProductList = this.saleOrderBasketList.filter((r) =>
          [2334, 2789, 1941, 1933, 2738, 2739, 2746, 2743, 2744, 2740, 2849, 2847, 2741, 2742, 2854, 2853, 2800, 2965, 2966, 1078, 1507, 2885, 2960, 2893, 2018, 2107, 2843, 3157, 3158, 3159, 3160, 3161].includes(r.productId)
        );

        let sumOfFullInvoiceQuantity = fullInvoiceProductList.reduce((acc, ele) => {
          return acc + ele.amount;
        }, 0);

        //Kural 1
        if (this.saveOrder.selectedPaymentType == 7 && (this.saveOrder.salePriceCurrencyId != 3 || this.saveOrder.isFullInvoice == false)) {
          await this.$swal.fire({
            icon: "warning",
            title: "Ödeme türü  TL ve Tam Fatura olmalıdır",
            text: "Ödeme türü kurumsal olan işlemler için para türü TL ve Tam Fatura olmalıdır",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }

        //Kural 3
        if (sumOfFullInvoiceQuantity > 0 && this.saveOrder.isFullInvoice == false) {
          await this.$swal.fire({
            icon: "warning",
            title: "Ürün Grubu Tam Fatura Hatası",
            text: `ProductId si  2334, 2789, 1941, 1933, 2738, 2739, 2746, 2743, 2744, 2740, 2849, 2847, 2741, 2742, 2854, 2853, 2800, 2965, 2966, 1078, 
                    1507, 2885, 2960, 2893, 2018, 2107, 2843, 3157, 3158, 3159, 3160, 3161 olan ürünler için tam fatura seçili olmalıdır.`,
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }

        //Kural 3
        if (this.saveOrder.selectedPaymentType == 4 && this.saveOrder.salePriceCurrencyId == 3) {
          await this.$swal.fire({
            icon: "warning",
            title: "Hata",
            text: "Ödeme türü açık hesap olan işlemler için para türü $ veya € olmalıdır",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }
      }

      //Bu kısım Sale Rule içindir.
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (!this.saveOrder.customerId || this.saveOrder.customerId <= 0) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Lütfen müşteri seçtiğinizden emin olunuz!",
        });
        return;
      }
      if (this.selectedCustomer.isOnlineCustomer && this.saveOrder.saleOrderType != 2) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "E-Ticaret müşterisi için satış türü sadece Internet seçilebilir!",
        });
        return;
      }
      if (this.saveOrder.products.length <= 0) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Lütfen ürün seçtiğinizden emin olunuz!",
        });
        return;
      }

      /////******************///////////////////

      for (let x = 0; x < this.saleOrderBasketList.length; x++) {
        //id boşsa id alanı oluştur

        if (!this.saveOrder.products[x].id) this.saveOrder.products[x].id = -1;
        //wareHouseId alanı boşsa oluştur
        if (!this.saveOrder.products[x].wareHouseId) this.saveOrder.products[x].wareHouseId = -1;

        //price alanı boşsa sellPrice dan al
        if (!this.saveOrder.products[x].price || this.saveOrder.products[x].price <= 0) this.saveOrder.products[x].price = this.saleOrderBasketList[x].salePrice;

        //priceDiscounted=sellprice
        this.saveOrder.products[x].priceDiscounted = this.saleOrderBasketList[x].salePrice;

        //productamount=quantity
        this.saveOrder.products[x].productAmount = this.saleOrderBasketList[x].amount;
        this.saveOrder.products[x].priceId = this.saveOrder.salePriceCurrencyId;
      }

      let postModel = {
        orderCreateMethod: "OrderWizard",
        customerId: this.saveOrder.customerId,
        orderNote: this.saveOrder.orderNote,
        saleOrderType: this.saveOrder.saleOrderType,
        createdDate: this.saveOrder.arrangementDate,
        validUntil: this.saveOrder.validityDate,
        taxIncluded: this.saveOrder.taxIncluded,
        currencyType: this.saveOrder.salePriceCurrencyId,
        paymentType: this.saveOrder.selectedPaymentType,
        deliveryType: this.saveOrder.saleDeliveryType,
        deliveryAddress: this.saveOrder.customerDeliverAddress,
        OrderLines: this.saveOrder.products,
        price: this.grandTotal.sumUnitPrice,
        priceDiscounted: this.grandTotal.priceDiscounted,
        discount: this.grandTotal.priceDiscounted,
        discountPercent: this.grandTotal.discountPercent,
        isFullInvoice: this.saveOrder.isFullInvoice,
      };

      this.$vs.loading();
      let r = await repository.postEntity("Sale/createOrder", postModel);
      this.$vs.loading.close();
      if (r.isSuccessful) {
        await this.$swal.fire({
          icon: "success",
          title: "İşlem Başarılı",
          //text: "",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });

        this.$router.push("../Sales/");
      }
    },
  },
  created() {
    if (this.$route.params != null && this.$route.name == "SaleWizardWithCustomerId" && this.$route.params.customerId > 0) {
      let customerId = parseInt(this.$route.params.customerId);
      this.searchQuery = "CustomerId=" + customerId;
      this.search();
    }
    Promise.all([this.showSaleOrderBasket(), this.getCurrencies(), this.getOrderTypes(), this.getPaymentTypes(), this.getSaleDeliveryType()]);
    this.saveOrder.arrangementDate = this.getDate;
    this.saveOrder.validityDate = new Date(new Date(this.saveOrder.arrangementDate).getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 16);
  },
  computed: {
    getDate() {
      let d = new Date();
      d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      return d.toISOString().substr(0, 16);
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  mounted() {
    document.getElementsByClassName("wizard-header")[0].style.display = "none";
    document.getElementsByClassName("wizard-card-footer")[0].style.display = "none";
    window.ab = this.$refs.formWizard;
  },
};
</script>
<style lang="scss">
.select {
  width: 50px;
  display: inline-block;
  margin-left: 10px;
  .vs__actions {
    display: none;
  }
}
</style>
